import { combineReducers } from 'redux'
import { routerReducer, RouterState } from 'react-router-redux'
import { reducer as form, FormStateMap } from 'redux-form'

export interface StoreState {
  router: RouterState,
  form: FormStateMap
}

export default combineReducers<StoreState>({
  routing: routerReducer,
  form
})



// WEBPACK FOOTER //
// ./src/reducers/index.tsx